import { UploadProvider } from './UploadContext';
import { combineComponents } from '@/utils/combineComponents';

const providers = [UploadProvider];

export const AppContextProvider = combineComponents(...providers);
